import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_URL = `${BACKEND_URL}/api`;
export const api = axios.create({ baseURL: API_URL, withCredentials: true });

export async function streamSSE(path, payload, onDelta, options = {}) {
  const response = await fetch(`${API_URL}${path}`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
    signal: options.signal,
    credentials: "include",
  });
  if (!response.ok || !response.body) throw new Error("The AI service could not start.");
  const reader = response.body.getReader();
  const decoder = new TextDecoder();
  let buffer = "";
  let completed = null;
  while (true) {
    const { value, done } = await reader.read();
    buffer += decoder.decode(value || new Uint8Array(), { stream: !done });
    const events = buffer.split("\n\n");
    buffer = events.pop() || "";
    for (const event of events) {
      const line = event.split("\n").find((part) => part.startsWith("data: "));
      if (!line) continue;
      const data = JSON.parse(line.slice(6));
      if (data.type === "delta") onDelta(data.content);
      if (data.type === "progress") options.onProgress?.(data.message);
      if (data.type === "error") throw new Error(data.message);
      if (data.type === "done") completed = data;
    }
    if (done) break;
  }
  return completed;
}
